import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    component: ()=> import('./view/layout'),
    redirect: '/faq',
    children: [
      {
        path: '/faq',
        component: () => import('./view/faq'),
        redirect: '/faq/list',
        children: [
          {
            name: 'faq-list',
            path: '/faq/list',
            component: () => import('./view/faq/faq-list'),
            meta: {
              title: '常见问题'
            },
          },
          {
            name: 'faq-detail',
            path: '/faq/detail',
            component: () => import('./view/faq/faq-detail'),
            meta: {
              title: 'FAQ详情'
            }
          },
        ]
      },
      {
        path: '/customer',
        component: () => import('./view/customer'),
        redirect: '/customer/list',
        children: [
          {
            name: 'qs-list',
            path: '/customer/list',
            component: () => import('./view/customer/qs-list'),
            meta: {
              title: '工单列表'
            }
          },
          {
            name: 'qs-detail',
            path: '/customer/detail',
            component: () => import('./view/customer/qs-detail'),
            meta: {
              title: '工单详情'
            }
          }
        ]
      },
      
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({ routes });

// router.beforeEach((to, from, next) => {
//   const title = to.meta && to.meta.title;
//   if (title) {
//     document.title = title;
//   }
//   next();
// });

export {
  router
};
